/******************************************************************
 * Input client side search feature
 *****************************************************************/
var TmplData = require('./mustache-tmpl.js');

$(function () {
    var timer,
        delayTime = 500;

    function isInArray(str, array) {
        if (!array) {
            return false;
        }

        for (var i = 0; i < array.length; i++) {
            if (array[i] === str) {
                return true;
            }
        }

        return false;
    }

    function removeUnmatchedData(data, ele, ignoreProps) {
        var removed = false;
        for (var i = data.length - 1; i >= 0; i--) {
            var notmatch = true;
            for (var prop in data[i]) {
                if (isInArray(prop, ignoreProps)) {
                    continue;
                }

                if (data[i][prop].toUpperCase().indexOf($(ele).val().toUpperCase()) !== -1) {
                    notmatch = false;
                    break;
                }
            }

            if (notmatch) {
                removed = true;
                data.splice(i, 1);
            }
        }

        return removed;
    }

    // insert unmatched text when no data matched
    function insertNoMatchText(searchResult, root, containerSelector) {
        if (searchResult[root].length === 0) {
            $(containerSelector).append(
                `<div class="nothing-display">
                    <span class="nothing-display-icon" data-iconmap="nothing-display-icon"></span>
                    <span>No matching result available.</span>
                </div>`
            );
            window.MvpFE.mapIcons();
        }
    }

    // Bind search input, only for one data source
    function bindSearchInput (inputSelector, root, excludeProps, dataVarName, tmplId, containerSelector) {
        $(document).on('keyup', inputSelector, function () {
            clearTimeout(timer);
            var me = this;

            timer = setTimeout(function () {
                //deep copy objects
                var searchResult = jQuery.extend(true, {}, TmplData[dataVarName]);

                if (searchResult[root]) {
                    var removedData = removeUnmatchedData(searchResult[root], me, excludeProps);
                    if (removedData) {
                        //only reset template when some data has been removed
                        TmplData.setTemplateData(tmplId + '_search', searchResult, containerSelector);
                    } else {
                        TmplData.setTemplateData(tmplId, TmplData[dataVarName + 'Formated'], containerSelector);
                    }

                    insertNoMatchText(searchResult, root, containerSelector);
                }
            }, delayTime);
        });
    }

    // Transfer Money payee search - because there are two data source, do not use common function
    $(document).on('keyup.payeesSearchInput', '.payees-search-input', function () {
        clearTimeout(timer);
        var me = this;

        timer = setTimeout(function () {
            //deep copy objects
            var searchResultMyAccount = jQuery.extend(true, {}, TmplData.dataMyAccount),
                searchResultPayees = jQuery.extend(true, {}, TmplData.dataPayeesSearch);

            //my account search
            if (searchResultMyAccount.myAccountListItem) {
                var removedMyAccounts = removeUnmatchedData(searchResultMyAccount.myAccountListItem, me, ['key']);
                if (removedMyAccounts) {
                    //only reset template when some data has been removed
                    TmplData.setTemplateData('template_payees_myaccount', searchResultMyAccount, '.payees-myaccount');
                } else {
                    TmplData.setTemplateData('template_payees_myaccount', TmplData.dataMyAccount, '.payees-myaccount');
                }
                insertNoMatchText(searchResultMyAccount, 'myAccountListItem', '.payees-myaccount');
            }

            //external account search
            if (searchResultPayees.payees) {
                var removedExternalAccounts = removeUnmatchedData(searchResultPayees.payees, me, ['key', 'targetId']);
                if (removedExternalAccounts) {
                    //only reset template when some data has been removed
                    TmplData.setTemplateData('template_payees_external_account_search', searchResultPayees, '.payees-external-accounts');
                } else {
                    TmplData.setTemplateData('template_payees_external_account', TmplData.dataPayeesFormated, '.payees-external-accounts');
                }
                insertNoMatchText(searchResultPayees, 'payees', '.payees-external-accounts');
            }
        }, delayTime);
    });

    // BPay biller search
    bindSearchInput('.biller-search-input', 'billers', ['key', 'changeUrl', 'payUrl'], 
        'dataBillers', 'template_billers', '.bpay-biller-list');

    // Bpay add new biller search
    bindSearchInput('.new-biller-search-input', 'billers', ['key', 'ref', 'changeUrl', 'payUrl', 'href'], 'dataNewBillers', 
        'template_new_billers', '.bpay-new-billers-list');

    // Term Deposit Maintenance | Cheque and Deposits - Cheque Tab Payee Search
    bindSearchInput('.term-deposit-cheque-to-payee-search-input', 'payees', ['key', 'changeUrl', 'payUrl'], 
        'dataChequeToPayees', 'template_term_deposit_cheque_to_payee', '.term-deposit-cheque-to-payee-list');
    
    // Term Deposit Maintenance - Credit External Tab Payee Search
    bindSearchInput('.common-external-payee-search-input', 'payees', ['key', 'changeUrl', 'payUrl'], 
        'dataExternalPayees', 'template_common_external_payee', '.common-external-payee-list');

    // Institution Payee Search
    bindSearchInput('.institution-search-input', 'payees', ['key', 'changeUrl', 'payUrl'], 
        'dataInstitutionPayee', 'template_institution_payee', '.institution-payee-list');

    // External Account search
    bindSearchInput('.external-account-search-input', 'payees', ['key', 'changeUrl', 'payUrl'], 
        'dataExternalTransfer', 'template_external_transfer', '.external-transfer-list');        
    
    // International Transfer Recipients Payee Search
    bindSearchInput('.international-Recipients-search-input', 'internationalRecipients', ['key', 'changeUrl', 'payUrl'],
        'dataInternationalRecipients', 'template_international_recipients', '.international-transfer-recipient');

    //International Transfer IBAN/Bank Account Search 
    bindSearchInput('.international-transfer-search-bank-iban-input, .international-transfer-search-bank-swift-input, .international-transfer-search-bank-name-input, .international-transfer-search-bank-city-input', 'internationalSearchBank', ['key', 'changeUrl', 'payUrl'],
        'dataInternationalSearchBank', 'template_iban_select_bank', '.international-transfer-search-bank-list');
    
});